if (!customElements.get('kiive-product-videos')) {
 customElements.define('kiive-product-videos', class extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.track = this.querySelector('.kvpv__track');
   this.addEventListener('click', event => {
    const play = event.target.closest('[data-kvpv-play]');
    const close = event.target.closest('[data-kvpv-close]');
    if (close) { this.stop(close.closest('[data-kvpv-card]')); return; }
    if (!play || !/^[a-zA-Z0-9_-]{11}$/.test(play.dataset.kvpvPlay)) return;
    event.preventDefault();
    const card = play.closest('[data-kvpv-card]');
    document.dispatchEvent(new CustomEvent('kiive:audio-active', {detail:{source:card}}));
    const players = window.KiiveAW?.instances;
    if (players) players.forEach(player => { if (!player.consoleV2 && player.isPlaying) player.stop(); });
    this.stopAll(card);
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube.com/embed/' + play.dataset.kvpvPlay + '?autoplay=1&rel=0&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    frame.title = play.dataset.title;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.addEventListener('load', () => frame.contentWindow?.postMessage(JSON.stringify({event:'listening',id:'kvpv-' + card.dataset.kvpvCard}), 'https://www.youtube.com'), {once:true});
    play.hidden = true;
    card.querySelector('.kvpv__media').append(frame);
    card.querySelector('[data-kvpv-close]').hidden = false;
   }, {signal});
   document.addEventListener('kiive:audio-active', event => this.stopAll(event.detail?.source), {signal});
   window.addEventListener('message', event => {
    if (event.origin !== 'https://www.youtube.com') return;
    const frame = Array.from(this.querySelectorAll('iframe')).find(item => item.contentWindow === event.source);
    if (!frame) return;
    let data;
    try { data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data; } catch { return; }
    if (data.event === 'onReady') frame.contentWindow.postMessage(JSON.stringify({event:'command',func:'addEventListener',args:['onStateChange']}),'https://www.youtube.com');
    if (data.event === 'onStateChange' && data.info === 1) document.dispatchEvent(new CustomEvent('kiive:audio-active',{detail:{source:frame.closest('[data-kvpv-card]')}}));
   }, {signal});
   this.querySelector('[data-kvpv-prev]')?.addEventListener('click', () => this.move(-1), {signal});
   this.querySelector('[data-kvpv-next]')?.addEventListener('click', () => this.move(1), {signal});
   this.track.addEventListener('scroll', () => this.updateNavigation(), {signal,passive:true});
   this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
   this.resizeObserver.observe(this.track);
   document.addEventListener('shopify:block:select', event => {
    const card = Array.from(this.querySelectorAll('[data-kvpv-card]')).find(item => item.dataset.kvpvCard === event.detail.blockId);
    if (!card) return;
    if (this.dataset.carousel === 'true') this.track.scrollTo({left:card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior:'auto'});
    card.scrollIntoView({block:'center',inline:'nearest',behavior:'auto'});
   }, {signal});
   this.updateNavigation();
  }
  stop(card) {
   if (!card) return;
   card.querySelector('iframe')?.remove();
   const play = card.querySelector('[data-kvpv-play]');
   if (play) play.hidden = false;
   const close = card.querySelector('[data-kvpv-close]');
   if (close) close.hidden = true;
  }
  stopAll(except) { this.querySelectorAll('[data-kvpv-card]').forEach(card => { if (card !== except) this.stop(card); }); }
  move(direction) {
   this.stopAll();
   this.track.scrollBy({left:direction * this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  }
  updateNavigation() {
   const prev = this.querySelector('[data-kvpv-prev]'), next = this.querySelector('[data-kvpv-next]');
   if (prev) prev.disabled = this.track.scrollLeft <= 2;
   if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }
  disconnectedCallback() {
   this.controller?.abort();this.controller=null;this.resizeObserver?.disconnect();this.stopAll();
  }
 });
}
